/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable block-scoped-var */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-shadow */
/* eslint-disable func-names */
/* eslint react/prop-types:0 */
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {compose} from 'recompose';

const {PARTNER} = process.env;

const DelightedSurvey = () => {
  useEffect(() => {
    !(function (e, t, r, n, a) {
      if (!e[a]) {
        for (var i = (e[a] = []), s = 0; s < r.length; s++) {
          const c = r[s];
          i[c] =
            i[c] ||
            // eslint-disable-next-line no-loop-func
            (function (e) {
              return function () {
                const t = Array.prototype.slice.call(arguments);
                i.push([e, t]);
              };
            })(c);
        }
        i.SNIPPET_VERSION = '1.0.1';
        const o = t.createElement('script');
        // eslint-disable-next-line no-sequences
        (o.type = 'text/javascript'),
          (o.async = !0),
          (o.src =
            'https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/' +
            n +
            '/' +
            a +
            '.js');
        const p = t.getElementsByTagName('script')[0];
        p && p.parentNode.insertBefore(o, p);
      }
    })(
      window,
      document,
      [
        'survey',
        'reset',
        'config',
        'init',
        'set',
        'get',
        'event',
        'identify',
        'track',
        'page',
        'screen',
        'group',
        'alias',
      ],
      'r3805oBKiNAbteYA',
      'delighted',
    );
  }, []);
  return null;
};

const withDelightedSurvey = compose(connect(), (Comp) => (props) => {
  // When the user click the next button / link in the fifth step of the fisrt fundamental course, we show the survey
  if (props.isTheFifthStepInTheFirstCourse && PARTNER === 'BARMEJ') {
    const {dispatch} = props;
    // console.log('last stepof a course');

    const modifiedCompleteProgressHandler = () => {
      if (props.completeProgress) {
        props.completeProgress();
      }

      if (!window.delighted) {
        return;
      }

      const delightedObserver = new MutationObserver(
        (mutationsList, observer) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type === 'childList' &&
              mutation.addedNodes &&
              mutation.addedNodes.length
            ) {
              const delightedWrapper = Array.prototype.find.call(
                mutation.addedNodes, // NodeList don't have find method
                ({className}) =>
                  className === 'delighted-web delighted-web-desktop',
              );
              // Delighted interface appeared
              if (delightedWrapper) {
                // We don't need the observer anymore
                observer.disconnect();
                const submitButton = delightedWrapper.querySelector(
                  '.delighted-web-comment-submit',
                );
                submitButton.addEventListener('click', () => {
                  const selectedScoreButton = delightedWrapper.querySelector(
                    '.delighted-web-question-score-number.delighted-web-is-active',
                  );
                  const score = selectedScoreButton.innerText;
                  if (score >= 8) {
                    dispatch({type: 'TOGGLE_REFERRAL_POPUP'});
                  }
                });
              }
            }
          });
        },
      );
      delightedObserver.observe(document.body, {
        attributes: false,
        childList: true,
        subtree: true,
      });

      window.delighted.survey();

      // cleanup
      setTimeout(() => {
        // Maybe something went wrong, let's remove the observer, to be sure
        delightedObserver.disconnect();
      }, 20000);
    };

    return (
      <>
        <Comp {...props} completeProgress={modifiedCompleteProgressHandler} />
        <DelightedSurvey />
      </>
    );
  }

  return (
    <>
      <Comp {...props} />
    </>
  );
});

export default withDelightedSurvey;
